function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 5.375V14.125C15 17.625 14.125 18.5 10.625 18.5H5.375C1.875 18.5 1 17.625 1 14.125V5.375C1 1.875 1.875 1 5.375 1H10.625C14.125 1 15 1.875 15 5.375Z",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 4.0625H6.25",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 15.9625C8.74899 15.9625 9.35621 15.3553 9.35621 14.6062C9.35621 13.8572 8.74899 13.25 7.99996 13.25C7.25092 13.25 6.64371 13.8572 6.64371 14.6062C6.64371 15.3553 7.25092 15.9625 7.99996 15.9625Z",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.4cc043fc5b19d684b15f940caad13799.svg";
export { ForwardRef as ReactComponent };